module.exports = __webpack_public_path__ + "static/media/019-briefcase.355914dd.svg";